import $axios from '../config.js'
import { url } from '../api_urls/basfProductClient.js'
// 获取页面顶部信息
export function getLastUpdateTime (params) {
  return $axios.post(url.getLastUpdateTime, params)
}
// 获取页列表
export function findList (params) {
  return $axios.post(url.findList, params)
}
// 获取详情
export function getDetail (params) {
  return $axios.post(url.getDetail, params)
}
// 加入购物车
export function addToCart (params) {
  return $axios.post(url.addToCart, params)
}
// 购物车数量
export function getCartCount (params) {
  return $axios.post(url.getCartCount, params)
}
// 购物车列表
export function getCartList (params) {
  return $axios.post(url.getCartList, params)
}
// 删除购物车
export function removeCart (params) {
  return $axios.post(url.removeCart, params)
}
// 提交购物车
export function submitCart (params) {
  return $axios.post(url.submitCart, params)
}
// 详情页申请权限
export function applyForBasfProductTabAuth (params) {
  return $axios.post(url.applyForBasfProductTabAuth, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/basfProductClient.js